import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { sendApiRequest } from "../utils/api";
import LogoLoader from "./LogoLoader";

/* -------------------- CARD -------------------- */
const ExamCard = ({ exam }) => {
  const navigate = useNavigate();

  const { _id, name, description, thumbnail, fee } = exam;

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition overflow-hidden">
      {/* IMAGE */}
      <img
        src={thumbnail}
        alt={name}
        className="w-full h-[120px] sm:h-[130px] object-cover"
        onError={(e) => {
          e.target.src =
            "https://via.placeholder.com/400x200?text=Exam+Image";
        }}
      />

      {/* CONTENT */}
      <div className="p-4 text-center">
        <h3 className="text-[14px] sm:text-[15px] font-semibold text-gray-900 line-clamp-2">
          {name}
        </h3>

        <p className="text-[11px] sm:text-[12px] text-gray-500 mt-1 mb-3 line-clamp-2">
          {description}
        </p>

        <button
          onClick={() => navigate(`/exams/${_id}`)}
          className="bg-[#1f4fa3] hover:bg-[#163a7a]
                     text-white text-xs px-4 py-1.5 rounded-md transition"
        >
          {fee === 0 ? "Start Free" : "Learn More"}
        </button>
      </div>
    </div>
  );
};

/* -------------------- MAIN -------------------- */
const FeaturedExams = () => {
  const [examData, setExamData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExams = async () => {
      try {
        const response = await sendApiRequest("api/admin/exams", {}, "GET");
        if (response.status) {
          setExamData(response.data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchExams();
  }, []);

  if (loading) {
    return (
      <LogoLoader />
    );
  }

  return (
    <div className="bg-[#1d3a80] py-10 px-4">
      {/* SECTION TITLE */}
      <h2 className="text-white text-center text-3xl font-bold mb-6">
        Featured Exams
      </h2>

      {/* WHITE WRAPPER */}
      <div className="bg-[#f5f7fb] rounded-3xl p-6 max-w-7xl mx-auto">
        <h3 className="text-base font-semibold text-[#0f2a5f] mb-4">
          Popular Exams
        </h3>

        {/* ✅ GRID FIX */}
        <div
          className="
            grid
            grid-cols-2          /* 📱 Mobile: 2 cards */
            sm:grid-cols-2
            lg:grid-cols-3       /* 💻 Desktop */
            xl:grid-cols-4
            gap-5
          "
        >
          {examData.map((exam) => (
            <ExamCard key={exam._id} exam={exam} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedExams;
